//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VCard } from "vuetify/lib";

// header svgs
import IconNookHead from "@/assets/icons/nookphone/nook-head.svg?inline";
import IconNookGPS from "@/assets/icons/nookphone/nook-gps.svg?inline";
import IconNookService from "@/assets/icons/nookphone/nook-service.svg?inline";

import IconNavBrowse from "@/assets/icons/nav/browse.svg?inline";
import IconNavEditor from "@/assets/icons/nav/editor.svg?inline";
import IconNavFaq from "@/assets/icons/nav/faq.svg?inline";
import IconNavUpdates from "@/assets/icons/nav/updates.svg?inline";
import IconNavDiscord from "@/assets/icons/nav/discord.svg?inline";
import IconNavHome from "@/assets/icons/nav/home.svg?inline";
import IconNavAbout from "@/assets/icons/nav/about.svg?inline";
import IconNavTwitter from "@/assets/icons/nav/twitter.svg?inline";

import CancelButton from "@/components/modals/CancelButton.vue";

const menuTitleDefault = "Main Menu";
export default {
  name: "NookPhoneMenu",
  components: {
    VCard,
    IconNavHome,
    IconNavEditor,
    IconNavBrowse,
    IconNavFaq,
    IconNavAbout,
    IconNavUpdates,
    IconNavDiscord,
    IconNavTwitter,
    IconNookHead,
    IconNookGPS,
    IconNookService,
    CancelButton,
  },
  data: function () {
    return {
      menuTitle: "Main Menu",
    };
  },
  computed: {
    dateObj: () =>  new Date(),
    time: {
      get: () => {
      return new Date().toLocaleTimeString("en-US", {
        hour: "2-digit",
        timeZoneName: "short",
      });
      },
      set: (value) => {
        return value;
      }
    },
  },
  mounted() {
    const interval = setInterval(
      () =>
        (this.time = this.dateObj.toLocaleTimeString("en-US", {
          hour: "2-digit",
          timeZoneName: "short",
        })),
      1000
    );
  },
  methods: {
    enterNavItem: async function (menuTitle = menuTitleDefault) {
      this.menuTitle = menuTitle;
    },
    leaveNavItem: async function () {
      const curr = this.menuTitle;
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, 300);
      });
      if (this.menuTitle === curr) this.menuTitle = menuTitleDefault;
    },
  },
};
